import { useQuery } from 'react-query';
import { QueryKeys } from '@frontend/features/common/types';
import { AgencyFlightIntegrationListDto, PagedResponse } from '@bandido/shared/dtos';
import { AxiosError, AxiosResponse } from 'axios';
import { client } from '@frontend/features/common/services';
import { PagedFilter } from '@bandido/shared/dtos';

export interface useGetAllFlightIntegrationsByAgencyIdProps extends PagedFilter {
  agencyId: number;
  onErrorCallback?: (_e: AxiosError) => void;
  search?: string;
}

export const useGetAllFlightIntegrationsByAgencyId = ({
  agencyId,
  currentPage,
  onErrorCallback,
  pageSize,
  search,
}: useGetAllFlightIntegrationsByAgencyIdProps) =>
  useQuery({
    queryKey: [QueryKeys.getAllAgencyFlightIntegrations, currentPage, pageSize, search],
    queryFn: async (): Promise<PagedResponse<AgencyFlightIntegrationListDto> | undefined> => {
      try {
        const flightIntegrations: AxiosResponse<PagedResponse<AgencyFlightIntegrationListDto>, any> = await client.get(
          `agency-flight-integrations/${agencyId}`,
          {
            params: {
              currentPage,
              pageSize,
              search,
            },
          },
        );

        return flightIntegrations.data;
      } catch (e) {
        onErrorCallback && onErrorCallback(e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
  });
